import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7fcca107"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "prisoners-page",
  class: "bg-black text-white py-12"
}
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { style: {"border":"none","padding":"0","margin":"0"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sr-only" }, "Filter by prisoner status", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "prisoner-search",
  class: "sr-only"
}, "Search prisoners by name", -1))
const _hoisted_6 = { class: "flex items-center gap-4 mb-12" }
const _hoisted_7 = {
  key: 0,
  class: "auto-switch-notice",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "All Cases", -1))
const _hoisted_9 = { class: "results-row" }
const _hoisted_10 = {
  key: 0,
  class: "results-count"
}
const _hoisted_11 = { class: "results-actions" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "portrait-gallery-link",
  href: "/icons",
  "aria-label": "Browse the portrait gallery",
  title: "Portrait gallery"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "19",
    viewBox: "0 0 24 28",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.7",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "2.5",
      y: "2",
      width: "19",
      height: "24",
      rx: "2"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "10",
      r: "3.5"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M6 21v-1a6 6 0 0 1 12 0v1H6Z" })
  ])
], -1))
const _hoisted_13 = { class: "include-minor" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Include minor cases", -1))
const _hoisted_15 = {
  key: 0,
  class: "include-minor-auto"
}
const _hoisted_16 = {
  key: 1,
  role: "alert"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "load-more-spinner",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading more prisoners…", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

import useAirtable from '../../composables/useAirtable';
import axios from 'axios';
import {ref, watch, computed, onMounted, onUnmounted, nextTick} from "vue";
import {PrisonerRecord} from "@/@types/types";
import CardComponent from "@/components/database/CardComponent.vue";
import FiltersComponent from "@/components/database/FiltersComponent.vue";
import DatabaseMap from "@/components/database/DatabaseMap.vue";
import {useFilter} from "@/composables/useFilter";

export default /*#__PURE__*/_defineComponent({
  __name: 'DatabaseComponent',
  async setup(__props) {

let __temp: any, __restore: any

const { records, fetchRecords, filterFieldsObj } = useAirtable();
;(
  ([__temp,__restore] = _withAsyncContext(() => fetchRecords())),
  await __temp,
  __restore()
);
const filterObject = ref<any>({});
const cleanFilterObject = ref<Record<any, any>>({});
const nameSearch = ref<string>('');
const buttonFilter = ref<string>('imprisonedOrExiled')

const {checkPrisonerFilter} = useFilter()

// The URL and the filters stay in step both ways: /database/era/1980s opens
// with that era selected, and selecting an era rewrites the address bar to
// match. The path is the single source of truth for both directions, which is
// what makes the Back button work -- popstate gives us a new path and nothing
// else, so anything the path cannot express would be lost on the way back.
const FACET_KEYS = ['ideology', 'era', 'affiliation', 'state', 'race', 'gender'];

// The URL segment is matched against the real filter options rather than used
// as-is, because the option is "Black Panther Party" and the URL is
// "black-panther-party". Slugging both sides means a link works however it was
// written -- Anarchism, anarchism, ANARCHISM all land on the same page.
const slugifyFacet = (value: string): string =>
    (value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

const decode = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    // A malformed escape sequence in the URL is not worth throwing over.
    return value;
  }
};

/**
 * Parses /database/era/1980s/ideology/anarchism into {era: ["1980s"],
 * ideology: ["anarchism"]}. Facets chain as key/value pairs and several values
 * in one facet are comma-separated -- no option value in this data contains a
 * comma, and no two options in a facet share a slug, both checked.
 */
const facetsFromPath = (): Record<string, string[]> => {
  const parts = window.location.pathname.split('/').filter(Boolean);
  const facets: Record<string, string[]> = {};

  if (parts[0] !== 'database') return facets;

  for (let i = 1; i + 1 < parts.length; i += 2) {
    const key = parts[i];

    if (!FACET_KEYS.includes(key)) continue;

    facets[key] = parts[i + 1].split(',').map(decode).filter(Boolean);
  }

  return facets;
};

// Resolves URL segments to the actual option strings, dropping any that match
// nothing -- a link to an ideology that has since been renamed should show the
// database rather than an empty page.
const matchFacetValues = (key: string, values: string[]): string[] => {
  const options: string[] = (filterFieldsObj as any)[key] ?? [];

  return values
      .map(value => options.find(option => slugifyFacet(option) === slugifyFacet(value)))
      .filter((match): match is string => Boolean(match));
};

/** The filters a path asks for, with everything unmatchable already dropped. */
const filtersFromPath = (): Record<string, string[]> => {
  const resolved: Record<string, string[]> = {};

  Object.entries(facetsFromPath()).forEach(([key, values]) => {
    const matches = matchFacetValues(key, values);

    if (matches.length) resolved[key] = matches;
  });

  return resolved;
};

const applyFacetFromUrl = () => {
  const resolved = filtersFromPath();

  if (!Object.keys(resolved).length) return;

  filterObject.value = { ...filterObject.value, ...resolved };

  // Someone following a link to an era or an ideology wants to browse it, not
  // to see only the handful of those people still inside. The default status
  // filter would leave most of these links looking almost empty, so a deep
  // link opens on All Cases.
  buttonFilter.value = '';
};

// Runs during setup, after the top-level await on fetchRecords above, so the
// option lists are already populated and FiltersComponent is created with the
// selection in place.
applyFacetFromUrl();

const visibleCount = ref(20);
const loadMoreTrigger = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | null = null;

// Minor cases (brief detentions, low-significance arrests) are hidden by
// default; the checkbox beside the results count includes them.
const includeMinor = ref(false);

// Searching a name is a search for a person, not a browse of the significant
// cases: somebody typing "Kyle Snyder" wants Kyle Snyder, and a record being
// classified minor is no reason to tell them he does not exist. So a name
// search turns the filter off for as long as it lasts, and the checkbox
// visibly ticks itself rather than the filter changing behind the user's back.
//
// A deliberate toggle always wins. Unticking during a search means "I really
// do want minor cases hidden", and is remembered for later searches too;
// ticking it by hand outside a search survives the search being cleared.
const minorAutoEnabled = ref(false);
const minorUserSet = ref(false);

// Fires only on a real click, not on the programmatic changes below.
const onIncludeMinorToggled = () => {
  minorUserSet.value = true;
  minorAutoEnabled.value = false;
};

watch(nameSearch, (value) => {
  // Trimmed, to match the name filter itself: whitespace is not a search.
  if (value.trim() !== '') {
    if (!minorUserSet.value && !includeMinor.value) {
      includeMinor.value = true;
      minorAutoEnabled.value = true;
    }
  } else if (minorAutoEnabled.value) {
    // Only ever undo what this did; a hand-ticked box is left alone.
    includeMinor.value = false;
    minorAutoEnabled.value = false;
  }
});

// Computed property to generate filtered records
const filteredRecords = computed(() => {
  return records.value.filter((record) => {
    if (!includeMinor.value && record['Minor Case']) return false;
    return checkPrisonerFilter(record, buttonFilter, cleanFilterObject, nameSearch)
  });
});

const visibleRecords = computed(() => {
  return filteredRecords.value.slice(0, visibleCount.value);
});

// Keep the complete search index, but download case histories only for visible cards.
const details = ref<Record<string, PrisonerRecord>>({});
const pendingIds = new Set<string>();
const detailsError = ref(false);
const awaitingDetails = computed(() => visibleRecords.value.some(
  record => !record['Status Under Review'] && !details.value[record.id]
));
const loadVisibleDetails = async () => {
  const ids = visibleRecords.value.map(record => record.id)
    .filter(id => !details.value[id] && !pendingIds.has(id));
  if (!ids.length) return;
  ids.forEach(id => pendingIds.add(id));
  detailsError.value = false;
  try {
    for (let offset = 0; offset < ids.length; offset += 20) {
      const batch = ids.slice(offset, offset + 20);
      const response = await axios.get('/api/prisoners', { params: { ids: batch } });
      response.data.forEach((record: PrisonerRecord) => {
        details.value[record.id] = { ...record, visible: true };
      });
      if (batch.some(id => !details.value[id])) throw new Error('Some profiles are unavailable');
    }
  } catch {
    detailsError.value = true;
  } finally {
    ids.forEach(id => pendingIds.delete(id));
  }
};
watch(() => visibleRecords.value.map(record => record.id).join(','), loadVisibleDetails);

const hasMore = computed(() => {
  return visibleCount.value < filteredRecords.value.length;
});

// Reset visible count when filters change
watch([buttonFilter, cleanFilterObject, nameSearch, includeMinor], () => {
  visibleCount.value = 20;
});

// Auto-fallback to "All Cases" when the status filter is what emptied the
// results. Picking an era like 1700s while "In Custody or Exiled" is selected
// would otherwise show nothing, when the era itself has plenty of records --
// so the status filter drops away rather than the page looking empty.
// autoSwitchedFrom drives the notice, and is cleared as soon as the user
// changes the status filter themselves.
const autoSwitchedFrom = ref<string>('');

const statusFilterLabels: Record<string, string> = {
  imprisonedOrExiled: 'In Custody or Exiled',
  inExile: 'In Exile',
  inCustody: 'In Custody',
  released: 'Released',
  awaitingTrial: 'Awaiting Trial',
};

// Same filtering, but ignoring the status buttons -- tells us whether the
// other filters on their own would have matched anything.
const matchesWithoutStatus = computed(() => {
  const noStatus = ref('');
  return records.value.filter((record) => {
    if (!includeMinor.value && record['Minor Case']) return false;
    return checkPrisonerFilter(record, noStatus, cleanFilterObject, nameSearch);
  }).length;
});

watch([filteredRecords, matchesWithoutStatus], () => {
  if (
    buttonFilter.value !== '' &&
    filteredRecords.value.length === 0 &&
    matchesWithoutStatus.value > 0
  ) {
    autoSwitchedFrom.value = statusFilterLabels[buttonFilter.value] ?? buttonFilter.value;
    buttonFilter.value = '';
  }
});

// A deliberate change of the status filter dismisses the notice.
watch(buttonFilter, (value) => {
  if (value !== '') autoSwitchedFrom.value = '';
});

onMounted(() => {
  window.addEventListener('popstate', onPopState);

  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && hasMore.value && !awaitingDetails.value && !detailsError.value) {
      visibleCount.value += 20;
    }
  }, { rootMargin: '200px' });
  if (loadMoreTrigger.value) observer.observe(loadMoreTrigger.value);
});

onUnmounted(() => {
  window.removeEventListener('popstate', onPopState);
  observer?.disconnect();
});

watch(loadMoreTrigger, (el) => {
  observer?.disconnect();
  if (el) observer?.observe(el);
});



const hasActiveFilters = computed(() => {
  if (nameSearch.value) return true;
  return Object.keys(cleanFilterObject.value).length > 0;
});

const clearFilters = () => {
  nameSearch.value = '';
  filterObject.value = {};
  cleanFilterObject.value = {};
  buttonFilter.value = 'imprisonedOrExiled';
  autoSwitchedFrom.value = '';
  // Clearing means back to defaults, including the remembered choice about
  // minor cases -- so the next name search auto-includes them again.
  includeMinor.value = false;
  minorAutoEnabled.value = false;
  minorUserSet.value = false;
  // Force FiltersComponent to reset by incrementing a key
  filterKey.value++;
};

const filterKey = ref(0);

watch(filterObject, (newValue, oldValue) => {
  const _filters: Record<string, string[]> = {}
  Object.keys(filterObject.value).forEach((key) => {
    const value = filterObject.value[key]
    if(value && value.length > 0) {
      _filters[key] = value
    }
  })

  cleanFilterObject.value = _filters
  // immediate, because a deep link sets filterObject during setup -- before
  // this watcher exists. Without it the dropdown would show the era selected
  // and the list would ignore it, since cleanFilterObject is what the filter
  // actually reads. Harmless on a normal load, where it derives {} from {}.
}, { deep: true, immediate: true });

// Resolve deep-link filters before requesting the first group of cards.
;(
  ([__temp,__restore] = _withAsyncContext(() => loadVisibleDetails())),
  await __temp,
  __restore()
);

// --- keeping the address bar in step -------------------------------------
//
// Set while the filters are being changed BY the URL (a Back button press), so
// that reacting to the URL does not immediately push the URL again.
let applyingFromUrl = false;

/**
 * The path representing the current filters. Every combination is expressible:
 * facets chain as key/value pairs and several values in one facet are joined
 * with commas, so an era plus an ideology is
 * /database/era/1980s/ideology/anarchism and two eras is
 * /database/era/1980s,1990s.
 *
 * Both the facet order and the values within a facet are sorted, so the same
 * selection always produces the same URL however it was arrived at -- which is
 * what stops the same view having two addresses and what makes the no-change
 * check below reliable.
 *
 * Status buttons and the name search are deliberately outside the scheme and
 * never affect the path.
 */
const pathForFilters = (): string => {
  const parts: string[] = [];

  FACET_KEYS.forEach((key) => {
    const values = cleanFilterObject.value[key];

    if (!Array.isArray(values) || !values.length) return;

    const slugs = values.map(slugifyFacet).filter(Boolean).sort();

    if (slugs.length) parts.push(key, slugs.join(','));
  });

  return parts.length ? `/database/${parts.join('/')}` : '/database';
};

watch(cleanFilterObject, () => {
  if (applyingFromUrl) return;

  const next = pathForFilters();

  // Nothing to say. Also the case on first load, where the path already
  // matches the filters a deep link just applied.
  if (next === window.location.pathname) return;

  window.history.pushState({ nppcDatabaseFacet: true }, '', next + window.location.search);
}, { deep: true });

/**
 * Back and Forward. The path is all popstate gives us, so the filters are
 * rebuilt from it rather than from any remembered state: an unrepresentable
 * combination was never pushed, so there is nothing to restore.
 */
const onPopState = () => {
  applyingFromUrl = true;

  // Replaced wholesale rather than merged: the path is the whole truth about
  // which filters are on, so a facet absent from it has been navigated away
  // from and must come off.
  const resolved = filtersFromPath();

  filterObject.value = resolved;

  if (Object.keys(resolved).length) buttonFilter.value = '';

  // Remount FiltersComponent so its dropdowns re-seed from the new value --
  // set after filterObject, so the fresh instance sees the new selection.
  filterKey.value++;

  // Released on the next tick, once the cleanFilterObject watcher above has
  // run for this change and declined to push it back.
  nextTick(() => { applyingFromUrl = false; });
};



return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_a_radio_group, {
          value: buttonFilter.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((buttonFilter).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, { value: "imprisonedOrExiled" }, {
              default: _withCtx(() => [
                _createTextVNode("In Custody or Exiled")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "" }, {
              default: _withCtx(() => [
                _createTextVNode("All Cases")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "inExile" }, {
              default: _withCtx(() => [
                _createTextVNode("In Exile")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "inCustody" }, {
              default: _withCtx(() => [
                _createTextVNode("In Custody")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "released" }, {
              default: _withCtx(() => [
                _createTextVNode("Released")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "awaitingTrial" }, {
              default: _withCtx(() => [
                _createTextVNode("Awaiting Trial")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        type: "search",
        id: "prisoner-search",
        placeholder: "Search by name",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nameSearch).value = $event)),
        "aria-label": "Search prisoners by name"
      }, null, 512), [
        [_vModelText, nameSearch.value]
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createBlock(FiltersComponent, {
          class: "flex-1",
          key: filterKey.value,
          filters: _unref(filterFieldsObj),
          "model-value": filterObject.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterObject).value = $event))
        }, null, 8, ["filters", "model-value"])),
        (hasActiveFilters.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: clearFilters,
              class: "clear-filters-btn"
            }, "Clear Filters"))
          : _createCommentVNode("", true)
      ]),
      (autoSwitchedFrom.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createTextVNode(" No results for “" + _toDisplayString(autoSwitchedFrom.value) + "” with these filters — showing ", 1),
            _hoisted_8,
            _createTextVNode(" instead. ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (filteredRecords.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(filteredRecords.value.length) + " results", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("label", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((includeMinor).value = $event)),
              onChange: onIncludeMinorToggled
            }, null, 544), [
              [_vModelCheckbox, includeMinor.value]
            ]),
            _hoisted_14,
            (minorAutoEnabled.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "on for name search"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRecords.value, (record) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!record['Status Under Review'] && details.value[record.id])
            ? (_openBlock(), _createBlock(CardComponent, {
                record: details.value[record.id],
                key: record.id
              }, null, 8, ["record"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256)),
      (detailsError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createTextVNode(" Some profiles could not be loaded. "),
            _createElementVNode("button", {
              type: "button",
              onClick: loadVisibleDetails
            }, "Try again")
          ]))
        : _createCommentVNode("", true),
      ((hasMore.value || awaitingDetails.value) && !detailsError.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            ref_key: "loadMoreTrigger",
            ref: loadMoreTrigger,
            class: "load-more-indicator",
            role: "status",
            "aria-live": "polite"
          }, _hoisted_19, 512))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})